module.exports = __webpack_public_path__ + "static/img/line-box.ade8393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/line-box.png
// module id = MnDJ
// module chunks = 0